<ng-template #monthDetails let-modal>
	<div class="modal-header">
		<h4> Brand Details</h4>
		<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"><i class="fa fa-close"></i></button>
	</div>
	<div class="modal-body">
		<div class="table mt-3" *ngIf="brand_details">

			<mat-paginator
			  [pageSizeOptions]="items_per_page"
			  [pageSize]="pagesizedefaultNop"
			></mat-paginator>

			<table class="table table-striped table-fixed table-hover" *ngIf="brand_details">
				<thead>
				<tr>
					<th>DOCUMENT#</th>
					<th>TYPE</th>
					<th>LOCATION#</th>
					<th>DATE</th>
					<th>ITEM#</th>
					<th>DESC</th>
					<th class="text-center">DISCOUNT</th>
					<th class="text-center">QTY</th>
					<th class="text-right">PRICE</th>
					<th class="text-right">TOTAL</th>
				</tr>
				</thead>
				<tbody>
				<tr *ngFor="let item of brand_details.items">
					<td>{{ item.transno }}</td>
					<td>{{ item.typename }}</td>
					<td>{{ item.loccode }}</td>
					<td>{{ item.trandate }}</td>
					<td>{{ item.stockid }}</td>
					<td>{{item.description}}</td>
					<td class="text-center">{{item.discountpercent | percent }}</td>
					<td class="text-center">{{ item.qty }}</td>
					<td class="text-right">{{item.price | currency }}</td>
					<td class="text-right">{{ item.discountedlinetotal | currency }}</td>
				</tr>
				</tbody>
			</table>
			<h4 class="text-center" *ngIf="!brand_details.items">
				No Results
			</h4>
		</div>
	</div>
	<div class="modal-footer">
	</div>
</ng-template>

<div class="cnp-wrap" [ngStyle]="themeVars">

	<!-- ── Floating accent icon ─────────────────────────────────────────────── -->
	<div class="cnp-icon-badge">
		<i class="material-icons">remove_shopping_cart</i>
	</div>

	<!-- ── Header ───────────────────────────────────────────────────────────── -->
	<div class="cnp-header">

		<div class="cnp-title-group">
			<span class="cnp-title">{{ title }}</span>
			<span class="cnp-subtitle">{{ days | number }}–{{ daysmax | number }} day window</span>
		</div>

		<div class="cnp-actions">
			<span class="cnp-mini-loading" *ngIf="exporting" title="Exporting...">
				<svg class="spinner" width="22" height="22" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
					<circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
				</svg>
			</span>
			<button class="cnp-icon-btn" (click)="loadData()" [disabled]="sending" title="Refresh">
				<i class="material-icons">refresh</i>
			</button>
			<button class="cnp-icon-btn" (click)="$event.preventDefault();buildExportHtml('xls')" [disabled]="exporting || sending || !data" title="Export Excel">
				<i class="fa fa-file-excel-o"></i>
			</button>
			<button class="cnp-icon-btn" (click)="$event.preventDefault();buildExportHtml('pdf')" [disabled]="exporting || sending || !data" title="Export PDF">
				<i class="fa fa-file-pdf-o"></i>
			</button>
			<button class="cnp-icon-btn"
					[class.cnp-icon-btn--active]="showFilters"
					(click)="showFilters = !showFilters"
					title="Filters">
				<i class="material-icons">tune</i>
			</button>
			<button class="cnp-icon-btn"
					[class.cnp-icon-btn--active]="flip === 'active'"
					(click)="flip === 'active' ? toggleFlip(false, '') : toggleFlip(data, title)"
					[title]="flip === 'active' ? 'Collapse' : 'View customers'">
				<i class="material-icons">{{ flip === 'active' ? 'expand_less' : 'expand_more' }}</i>
			</button>
		</div>
	</div>

	<!-- ── Summary stats ────────────────────────────────────────────────────── -->
	<div class="cnp-stats" *ngIf="data && !sending">
		<div class="cnp-stat">
			<span class="cnp-stat-val">{{ total | number:'1.0-0' }}</span>
			<span class="cnp-stat-lbl">Inactive Customers</span>
		</div>
		<div class="cnp-stat">
			<span class="cnp-stat-val">{{ avgDaysSince | number:'1.0-0' }}</span>
			<span class="cnp-stat-lbl">Avg Days Since Purchase</span>
		</div>
		<div class="cnp-stat">
			<span class="cnp-stat-val">{{ totalPriorSpend | currency }}</span>
			<span class="cnp-stat-lbl">Prior Spend At Risk (Page)</span>
		</div>
	</div>

	<!-- ── Filter drawer ────────────────────────────────────────────────────── -->
	<div class="cnp-filters" *ngIf="showFilters">
		<mat-form-field appearance="outline" class="cnp-field">
			<mat-label>Number Of Days</mat-label>
			<span matPrefix>#&nbsp;</span>
			<input matInput type="text" value="{{ days | number }}" (input)="updateDays($event)" class="text-right">
		</mat-form-field>
		<mat-form-field appearance="outline" class="cnp-field">
			<mat-label>Number Of Days Since</mat-label>
			<span matPrefix>#&nbsp;</span>
			<input matInput type="text" value="{{ daysmax | number }}" (input)="updateDaysMax($event)" class="text-right">
		</mat-form-field>
		<button class="cnp-apply-btn" (click)="loadData()" [disabled]="sending" title="Apply filters">
			<i class="material-icons">refresh</i>
			<span>Apply</span>
		</button>
	</div>

	<!-- ── Loading ──────────────────────────────────────────────────────────── -->
	<div class="cnp-loading" *ngIf="sending">
		<svg class="spinner" width="40" height="40" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
			<circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
		</svg>
	</div>

	<!-- ── Detail panel (collapsible) ───────────────────────────────────────── -->
	<div class="cnp-body" *ngIf="flip === 'active' && !sending">

		<mat-paginator #paginator
					   (page)="onPageChange($event)"
					   [length]="total"
					   [pageSize]="pagesizedefaultNop"
					   [disabled]="false"
					   [showFirstLastButtons]="showFirstLastButtons"
					   [pageSizeOptions]="showPageSizeOptions ? items_per_page : []"
					   [hidePageSize]="hidePageSize"
					   [pageIndex]="pageindex"
					   aria-label="Select page">
		</mat-paginator>

		<div class="cnp-table-wrap" *ngIf="data && data.length" #print_table>
			<table class="cnp-table">
				<thead>
					<tr>
						<th>Customer#</th>
						<th>Name</th>
						<th>Address1</th>
						<th>City</th>
						<th>Region</th>
						<th>Postal</th>
						<th>Email</th>
						<th>SalesPerson</th>
						<th>Last Seen</th>
						<th class="text-right">Total Spend</th>
						<th class="text-right">Avg Spend</th>
					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let d of data">
						<td><a class="cnp-link" [routerLink]="'/customers/view/'+d.debtorno">{{d.debtorno}}</a></td>
						<td class="cnp-cell-name">{{d.name}}</td>
						<td>{{d.address1}}</td>
						<td>{{d.address3}}</td>
						<td>{{d.address4}}</td>
						<td>{{d.address5}}</td>
						<td>{{d.details?.email}}</td>
						<td><span *ngIf="d.salesmanname">{{d.salesmanname.name}}</span></td>
						<td>{{d.lastseen}}</td>
						<td class="text-right cnp-cell-total">{{d.totalspend | currency}}</td>
						<td class="text-right">{{d.avgspend | currency}}</td>
					</tr>
				</tbody>
			</table>
		</div>

		<div class="cnp-empty" *ngIf="!data || !data.length">
			<i class="material-icons">search_off</i>
			<span>No inactive customers found for this window.</span>
		</div>

	</div>
</div>
